import {
  get,
  post,
  put,
  patch,
  del,
  createQueryParams,
  getLocalStorageData,
} from "../../../../services/axiosComponent";
import { serverData, serviceUrls } from "../../../../services/constant";

export const getFoodMenuMealList = async (data) => {
  data.siteId = getLocalStorageData("profileDetails")["_SITE"];
  data.regionId = getLocalStorageData("profileDetails")["_REGION"];
  console.log("data in meal list", data);
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/food/menu/meal/list",
    params: createQueryParams(data),
  });
};

export const deleteFoodMenuMeal = async (entityId) => {
  return await del({
    url: serviceUrls.HOSTEL_SERVICE + "/food/menu/meal",
    params: createQueryParams({ entityId }),
  });
};

export const getFoodMenuMealItemsList = async (data) => {
  data.siteId = getLocalStorageData("profileDetails")["_SITE"];
  data.regionId = getLocalStorageData("profileDetails")["_REGION"];
  console.log("data in meal items list", data);
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/food/menu/meal/item/list",
    params: createQueryParams(data),
  });
};

export const deleteFoodMenuMealItem = async(entityId)=>{
  return await del({
    url: serviceUrls.HOSTEL_SERVICE + "/food/menu/meal/item",
    params: createQueryParams({ entityId }),
  });
}

export const addFoodMenuMeal = async (data) => {
  return await put({
    url: serviceUrls.HOSTEL_SERVICE + "/food/menu/meal",
    data: data,
  });
};

export const updateFoodMenuMeal = async (data)=>{
  return await put({
    url: serviceUrls.HOSTEL_SERVICE + "/food/menu/meal",
    data: data,
  })
}

export const addFoodMealItem = async (data) => {
  return await post({
    url: serviceUrls.HOSTEL_SERVICE + "/food/menu/meal/item",
    data: data,
  });
};

export const updateFoodMealItem = async(data)=>{
  return await put({
    url: serviceUrls.HOSTEL_SERVICE + "/food/menu/meal/item",
    data: data,
  })
}